// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-UTfi","title":"styles_title__tJncI","input":"styles_input__73sNj"};